import { Checkbox } from "@fluentui/react-components";
import React from "react";

type Props = {
  list: string[];
  insurerName: string;
  onChange: (next: string[]) => void;
  disabled?: boolean;
};

function InsurerSelectionCheckbox({
  list,
  insurerName,
  onChange,
  disabled,
}: Props) {
  const current = list || [];
  const checked = current.includes(insurerName);

  return (
    <Checkbox
      disabled={disabled}
      checked={checked}
      onChange={(_ev, data) => {
        const next = current.filter((name) => name !== insurerName);
        if (data.checked) {
          next.push(insurerName);
        }
        onChange(next);
      }}
    />
  );
}

export default InsurerSelectionCheckbox;
